<template>
  <v-navigation-drawer
    persistent
    :mini-variant="false"
    :clipped="true"
    enable-resize-watcher
    :fixed="false"
    :value="$store.state.ui.openLeftNavDrawer"
    app
  >
    <!-- @input="$store.commit" -->
    <v-toolbar flat dense>
      <v-toolbar-title> People </v-toolbar-title>
    </v-toolbar>
    <v-list>
      <v-list-item to="/people/">
        <v-list-item-action>
          <v-icon>mdi-account-search</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Search People</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/people/bulk/">
        <v-list-item-action>
          <!-- <v-icon>mdi-account-cog</v-icon> -->
          <v-icon>mdi-checkbox-multiple-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Bulk Updates</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <recently-viewed-people />
    <!-- <v-list>
      <v-list-item to="/about/">
        <v-list-item-action>
          <v-icon>help</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>About</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/people/">
        <v-list-item-action>
          <v-icon>people</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>People</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list> -->
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import recentlyViewedPeople from "@/components/people/recentlyViewed.vue";

export default {
  components: {
    recentlyViewedPeople,
  },
};
</script>
